import React from 'react'
import { View, FlatList } from 'react-native'
import PropTypes from 'prop-types'

import Txt from '../../../Txt'
import { getDateFormat, getTimeFormat } from '../../../../tools/dataParse'

import useStyles from './useStyles'
import { useTheme } from '../../../../theming/ThemeProvider'
import { usePlatforms } from '../../../../hooks/usePlatforms'

const BidHistory = ({ offerHistory }) => {
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()
  const styles = useStyles(isTablet)
  return (
    <View style={styles.container}>
      {offerHistory.length
        ? (
          <FlatList
            data={offerHistory || []}
            renderItem={({ item, index }) => {
              const isEdgeTheOfferer = item.offerer === 'Edge'
              return (
                <View
                  style={[
                    styles.historyItem,
                    {
                      alignItems: isEdgeTheOfferer ? 'flex-start' : 'flex-end'
                    }
                  ]}
                >
                  <View
                    style={[
                      styles.triangle,
                      isEdgeTheOfferer ? styles.leftTriangle : styles.rightTriangle,
                      {
                        borderRightColor: isEdgeTheOfferer ? `${theme.SECONDARY_ATHENS_GRAY}4D` : 'transparent',
                        borderLeftColor: isEdgeTheOfferer ? 'transparent' : `${theme.SECONDARY_ATHENS_GRAY}80`
                      }
                    ]}
                  />
                  <View
                    style={[
                      styles.historyItemCard,
                      {
                        backgroundColor: `${theme.SECONDARY_ATHENS_GRAY}${isEdgeTheOfferer ? '4D' : '80'}`,
                        marginLeft: isEdgeTheOfferer ? 10 : 0,
                        marginRight: isEdgeTheOfferer ? 0 : 10,
                        borderTopLeftRadius: isEdgeTheOfferer ? 0 : 4,
                        borderTopRightRadius: isEdgeTheOfferer ? 4 : 0
                      }
                    ]}
                  >
                    <View>
                      <Txt
                        text={`$ ${item.rate || item.rate === 0 ? item.rate : ' - -'} USD`}
                        identity='subtitleBold'
                        color='LOCHMARA'
                      />
                      <Txt
                        text='Rate'
                        identity='body3'
                        color='SLATE_GRAY'
                      />
                    </View>
                  </View>
                  <View
                    style={[
                      styles.dateTime,
                      {
                        marginLeft: isEdgeTheOfferer ? 10 : 0,
                        marginRight: isEdgeTheOfferer ? 0 : 10
                      }
                    ]}
                  >
                    <Txt
                      text={item.offer_date
                        ? getDateFormat({
                          date: item.offer_date.substring(0, item.offer_date.length - 1),
                          offset: item.offer_date_offset
                        }) || '- -'
                        : '- -'}
                      identity='body3'
                      color='OUTER_SPACE'
                      style={styles.date}
                    />
                    <Txt
                      text={item.offer_date
                        ? getTimeFormat({
                          date: item.offer_date.substring(0, item.offer_date.length - 1),
                          offset: item.offer_date_offset
                        }) || '- -'
                        : '- -'}
                      identity='body3'
                      color='SLATE_GRAY'
                    />
                  </View>
                </View>
              )
            }}
            keyExtractor={(_, key) => key.toString()}
            testID='loadDetailsBidHistoryList'
            accessibilityLabel='loadDetailsBidHistoryList'
          />
        ) : (
          <Txt
            text='There are no registers of bid yet'
            identity='subtitle'
            color='OUTER_SPACE'
          />
        )}
    </View>
  )
}

BidHistory.propTypes = {
  offerHistory: PropTypes.array
}

BidHistory.defaultProps = {
  offerHistory: []
}

export default BidHistory
